import React from 'react';
import classNames from 'classnames';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import styles from '@pages/api-portal/styles.module.scss';
import { CatalogGroupIcon } from '@pages/api-portal/catalog-group-icon';
import { formatCatalogDate } from '@pages/api-portal/utils';
import { ApiGroup } from '@pages/api-portal/types';

interface GroupCardProps {
    group: ApiGroup;
    endpointCount: number;
    onEdit: (group: ApiGroup) => void;
    onDelete: (group: ApiGroup) => void;
}

/*
 * Summary card for one API group, with Edit/Delete icon actions.
 */
export function GroupCard({ group, endpointCount, onEdit, onDelete }: GroupCardProps) {
    return (
        <div className={styles.cardSplit} style={{ height: '100%' }}>
            <div className={styles.cardSplitBody}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <div className={styles.iconTile}>
                        <CatalogGroupIcon icon={group.icon} />
                    </div>
                    <div>
                        <h5 className={styles.cardTitle}>{group.name}</h5>
                        <span className={styles.mutedText} style={{ fontSize: 12 }}>
                            {group.endpointCount ?? endpointCount} endpoints
                        </span>
                    </div>
                </div>
                <p className={styles.mutedText} style={{ margin: 0 }}>
                    {group.description}
                </p>
            </div>
            <div className={styles.cardSplitFooter}>
                <span className={styles.mutedText} style={{ fontSize: 12 }}>
                    Created {formatCatalogDate(group.created)} · Updated {formatCatalogDate(group.updated)}
                </span>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                    <button type="button" className={classNames(styles.iconButton, styles.editAction)} onClick={() => onEdit(group)}>
                        <AiOutlineEdit />
                    </button>
                    <button
                        type="button"
                        className={classNames(styles.iconButton, styles.deleteAction)}
                        onClick={() => onDelete(group)}
                    >
                        <AiOutlineDelete />
                    </button>
                </div>
            </div>
        </div>
    );
}
